<template>
  <button
    v-if="fevo || !link.includes('http')"
    type="button"
    data-fevo-offer-id="2022-lions-group-tickets--1d53a3a"
    :data-fevo-sub-offer-id="link"
  >
    <div class="date" v-if="isTimeTBD">
      <div class="month"></div>
      <div class="day">TBD</div>
      <div class="year"></div>
    </div>
    <div class="date" v-else>
      <div class="month">
        {{
          format(new Date(`${props.date.replace(/-/g, "/")} 00:00:01`), "MMM")
        }}
      </div>
      <div class="day">
        {{ format(new Date(`${props.date.replace(/-/g, "/")} 00:00:01`), "d") }}
      </div>
      <div class="year">
        {{
          format(new Date(`${props.date.replace(/-/g, "/")} 00:00:01`), "yyyy")
        }}
      </div>
    </div>
    <div class="info">
      <div class="icon" v-if="icon !== ''">
        <img :src="`${$store.state.ASSET_URL}${icon}`" alt="" />
      </div>
      <div class="game">
        <p class="title">{{ title }}</p>
        <p class="time">{{ time }}</p>
      </div>
    </div>
  </button>
  <a v-else target="_blank" :href="link">
    <!-- TODO: This can change to a new filed to show the text for TBD -->
    <div class="date" v-if="time === 'TBD' || time === 'Week 3'">
      <div class="month"></div>      
      <div class="day">{{ time }}</div>
      <div class="year"></div>
    </div>
    <div class="date" v-else>
      <div class="day" v-if="isTimeTBD">TBD</div>
      <template v-else>
      <div class="month">
        {{
          format(new Date(`${props.date.replace(/-/g, "/")} 00:00:01`), "MMM")
        }}
      </div>
      <div class="day">
        {{ format(new Date(`${props.date.replace(/-/g, "/")} 00:00:01`), "d") }}
      </div>
      <div class="year">
        {{
          format(new Date(`${props.date.replace(/-/g, "/")} 00:00:01`), "yyyy")
        }}
      </div>
    </template>
    </div>
    <div class="info">
      <div class="icon" v-if="icon !== ''">
        <img :src="`${$store.state.ASSET_URL}${icon}`" alt="" />
      </div>
      <div class="game">
        <p class="title">{{ title }}</p>
        <p class="time">
          <!-- TODO: This can change to a new filed to show the text for TBD -->
          {{ time === "TBD" || time === "Week 3" ? "TBD" : time }}
        </p>
      </div>
      <div class="icon primetime" v-if="primetimeLogo !== ''">
        <img :src="`${$store.state.ASSET_URL}${primetimeLogo}`" alt="" />
      </div>
    </div>
  </a>
</template>

<script setup>
import { format } from "date-fns";
const props = defineProps({
  title: String,
  date: String,
  time: String,
  link: {
    type: String,
    default: "",
  },
  icon: {
    type: String,
    default: "",
  },
  primetimeLogo: {
    type: String,
    default: "",
  },
  fevo: Boolean,
});
</script>


<script>
export default {
  name:'GameTicket',
  computed: {
    isTimeTBD() {
      return this.time.includes('TBD');
    }
  }
}
</script>


<style lang="scss" scoped>
a,
button {
  display: flex;
  transition: all 0.5s;
  user-select: none;
  position: relative;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: #fff;
  overflow: hidden;
  > div {
    position: relative;
  }
  @media (hover: hover) {
    &:hover {
      transform: translateX(15px);
      box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.2);
      .date {
        background: linear-gradient(
            0deg,
            rgba(0, 0, 0, 0.2),
            rgba(0, 0, 0, 0.2)
          ),
          #0076b6;
        color: #fff;
      }
    }
  }
}
.date {
  transition: all 0.5s;
  background: rgba(#bbbbbb, 0.4);
  text-transform: uppercase;
  text-align: center;
  color: #0076b6;
  line-height: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 7px;
  width: 90px;
  flex-shrink: 0;
  font-size: 0.625rem;
  border-bottom-left-radius: 10px;
  overflow: hidden;
  font-family: "United Sans Ex Hv";
  font-weight: 900;
  height: 100%;
  .day {
    font-size: 1.125rem;
  }
}
.info {
  display: flex;
  position: relative;
  overflow: hidden;
  gap: 5px;
  flex-grow: 1;
  &:before {
    content: "";
    background-image: url("~@/assets/images/grunge.png");
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.1;
    pointer-events: none;
  }
  > div {
    box-sizing: border-box;
    display: flex;
  }
  .icon {
    padding: 0 10px;
    flex-shrink: 0;
    align-items: center;

    img {
      width: 65px;
      height: 65px;
      flex-shrink: 0;
      @media (min-width: 750px) and (max-width: 1000px) {
        width: 50px;
        height: 50px;
      }
    }
    &.primetime {
      margin-left: auto;
    }
  }
  .game {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 15px 5px;
  }
  p {
    font-family: "United Sans Cd Hv";
    font-weight: 900;
    font-size: 1.5rem;
    line-height: 1;
    text-transform: uppercase;
    color: #0076b6;
    &.time {
      font-family: "PF DinDisplay Pro";
      font-weight: 500;
      font-size: 1rem;
      color: #54585a;
      margin-top: 2px;
    }
  }
}
</style>
